import { baseURL } from "../utility/api";

const ProductBaseURL = `${baseURL}v1/admin/asset`;
const CommissionListingBaseURL = `${baseURL}v1/admin/commissions/order/list`;
const AirDropBaseURL = `${baseURL}v1/admin/airdrop-assets`;

export { ProductBaseURL, CommissionListingBaseURL , AirDropBaseURL};
